




import { Component, Vue } from 'vue-property-decorator';
import Jobseeker from './Jobseeker.vue';
import Myreferrals from './Myreferrals.vue';
import Referrals from './Referrals.vue';
import { vxm } from '@/store.vuex';
import { JobsStore } from '@/models/jobs/jobs.vuex';
import { Job } from '@/models/jobs/job';
import { ReferralPayload } from '../models/referrals/referralPayload';
import { Referral } from '../models/referrals/referral';
import { ApplyRequestWrapper } from '../models/jobs/jobapply';
import router from '../router';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'JobDetails',
  components: {
    Jobseeker,
    Myreferrals,
    Referrals,
  },
})
export default class JobReferralDetails extends Vue {
  $wlToastr: any;
  $moment: any;
  private showDetail: boolean = false;

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  setNavigation(path: string) {
    this.$cookies.set('NavigateTo_ID', path, 600);
  }

  goToUpload(jid: string) {
    const vm = this;
    if (!vxm.users.getToken) {
      this.setNavigation('JobDetails:' + jid);
      this.$router.push({ name: 'Login' });
    } else {
      vxm.jobs.setJobID(parseInt(jid, 10));
      const jobApply = new ApplyRequestWrapper();
      jobApply.accessToken = vxm.users.getToken;
      jobApply.applyRequest.jobPostingId = parseInt(jid, 10);
      jobApply.applyRequest.referralCode = this.$route.params.referralCode;
      jobApply.applyRequest.companyCode = vxm.jobs.BrandingInfo.companycode;

      const respPromise: any = vxm.jobs.getNexSteps(jobApply);
      Promise.all([respPromise]).then((values) => {
        if (values[0]) {
          if (!values[0].success) {
            if (values[0].errorCode === '1002') {
              const errorMessageText = values[0].errorMessage;
              vm.$wlToastr('error', errorMessageText, vm.$t('MyJobListing_JobApplication'));
            }
          } else {
            if (values[0].nextPage === 'success') {
              const successMessage = this.$t('jobs.successfully.applied');
              vm.$wlToastr('success', successMessage, vm.$t('MyJobListing_JobApplication'));
            }
          }
        }
      });
    }
  }

  goToReferral(jid: string) {
    vxm.referrals.setJobID(parseInt(jid, 10));
    if (vxm.users.isLoggedIn === false) {
      this.$router.push({ name: 'JobShare', params: { JobID: jid } });
    } else {
      const referral = new Referral();
      referral.jobPostingId = parseInt(jid, 10);
      referral.userFullName =
        vxm.users.myUserProfile.firstName +
        ' ' +
        vxm.users.myUserProfile.lastName;
      referral.email = vxm.users.myUserProfile.email;
      referral.referralCode = this.$route.params.referralCode;
      referral.companyCode = vxm.jobs.BrandingInfo.companycode;
      console.log(referral);
      vxm.referrals.jobShareReferral(referral);
    }
  }

  goToCompanyDetail(ccode: string) {
    this.$router.push({ name: 'CompanyProfile', params: { Code: ccode } });
  }

  getDistance(job: Job) {
    if (job.distance > 0.1) {
      return job.distance.toFixed(1);
    } else {
      return '< 0.1';
    }
  }

  getJobReferralProgramExists(job) {
    if (job.companyReferralIncentive != null) {
      return job.companyReferralIncentive.companyReferralIncentiveName !== 'NA'
        ? true
        : false;
    }
    return false;
  }
  get jobDetail(): Job[] {
    const jobs: Job[] = [];
    jobs.push(vxm.referrals.ReferralWrapper.jobInfo);
    return jobs;
  }

  mounted() {
    const jobPostingId = vxm.referrals.ReferralWrapper.jobInfo.jobPostingId;
    const referralCode = vxm.referrals.ReferralWrapper.referralCode;
    const isMobileDevice = vxm.utility.isMobileDevice;
    const mobileAppsessionToken =
      this.$route.query.mobileAppsessionToken !== 'undefined'
        ? this.$route.query.mobileAppsessionToken
        : '';

    const iOSfallback =
      this.$route.query.fallback !== undefined
        ? this.$route.query.fallback
        : '';
    const fallback = iOSfallback === 'iOS' ? false : true;

    console.log('isMobileDevice', isMobileDevice);
    const iOS = vxm.utility.isIos;
    console.log('iOS', iOS);
    let appurl = '';

    if (iOS) {
      if (fallback) {
        appurl = (<any>window).location.href + '?fallback=iOS';
        vxm.utility.iphoneURLCall(appurl);
      }
    }
    vxm.jobs.setJobID(jobPostingId);
    localStorage.jobviewpage = true;
    this.$router.push({
      name: 'Jobdetails',
      params: { JobID: jobPostingId + '' },
    });
    vxm.jobs.setJobAdminMessage(
      vxm.referrals.ReferralWrapper.referralEventDescription,
    );
  }

  toggleReferrals() {
    this.showDetail = !this.showDetail;
  }

  getToggleValue() {
    return this.showDetail;
  }

  renderDate(xDate: Date): string {
    if (vxm.jobs.getCompanyDateFormat) {
      return (
        'STARTING: ' +
        this.$moment(xDate).format(vxm.jobs.getCompanyDateFormat.toUpperCase())
      );
    }
    return 'STARTING: ' + this.$moment(xDate).format('DD-MMM-YYYY');
  }
  getCompanyLogoUrl(companyCode: string): string {
    return vxm.jobs.getCompanyLogoUrl(companyCode);
  }

  getFristCapitalletter(value: string): string {
    if (!value) return '';
    value = value.toString();
    return value
      .trim()
      .charAt(0)
      .toUpperCase();
  }
}

// tslint:disable-next-line:semicolon
